<template>
    <div class="div-wrapper">

        <div class="d-flex justify-content-between align-items-start pb-3 mb-3">
            <div style="width: 100%;">
                <h5 class=" mb-2" style="color: #0055A6; font-weight: bolder;">{{ $t("fileTypesPolicy") }}</h5>
                <div class="d-flex justify-content-between align-items-start col-10" style="padding-left: 0;">
                    <p class="text-muted mb-2">
                        {{ tooltip.headers.fileTypesPolicyHeader }}
                    </p>
                </div>
            </div>
            <div class="align-self-center">
                <button type="button" class="actions-btn" @click="menu.toggle($event)">
                    <span class="label">{{ $t("actions2") }}</span>
                    <span class="divider"></span>
                    <i :class="['chevron', isMenuOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down']"></i>
                </button>
                <Menu ref="menu" :model="items" :popup="true" @show="isMenuOpen = true" @hide="isMenuOpen = false" />
            </div>
        </div>

        <div>
            <div class="d-flex justify-content-end gap-3 mb-3">
                <Button class="custom-icon-button" @click="showEdit('Add Rule', FileTypePolicyForm, 'add')">
                    <i class="ag-icon ag-icon_add_icon"></i>
                    <span class="label-text">{{ $t("newFileType") }}</span>
                </Button>
            </div>
            <div class="table-border-div" style="">
                <div class="input-class d-flex align-items-center gap-2 mb-3 px-2 ">
                    <TabsFilter v-model:search="searchQuery" @clear="clearSearch" v-model:status="statusFilter" />
                </div>
                <ag-card
                    :module="{ ...fileTypePolicyModule, component: { ...fileTypePolicyModule.component, options: { ...fileTypePolicyModule.component.options, rows: filteredFileExtensionRows } } }"
                    @edit="(rowData) => editFunction2(rowData)"
                    @deleteClick="(rowData) => deleteFileTypePolicy(rowData)"
                    @copyClick="(rowData) => copyFunction(rowData)">
                </ag-card>
            </div>

        </div>


    </div>

    <EditPanel :show-enabled="true" v-model="showPanel" :title="formTitle" :form-component="formFileName" :form-type="formType"
        v-model:form="formModel" @save="saveHandler" @cancel="cancelHandler" />
    <ag-loading v-if="loading" />
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import FileTypePolicyTable from "@/helpers/pages/FileTypesPolicy/FileExtension.ts";
import AgCard from "@/components/ag-card/index.vue";
import EditPanel from '@/components/ag-edit-panel/index.vue'
import AppGroupForm from '@/components/ag-edit-panel/forms/app-group-form.vue'
import FileTypePolicyForm from '@/components/ag-edit-panel/forms/file-type-policy-form.vue'
import Swal from 'sweetalert2';
import { useRoute, useRouter } from "vue-router";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import TabsFilter from '@/components/ag-tabs-filter/index.vue'
import routerPage from '@/router/index'
import AgLoading from "@/components/ag-loading/index.vue";
import tooltip from '@/assets/tooltips/en.json';
const loading = ref(false);
const store = useStore();
let fileTypePolicyModule = ref(FileTypePolicyTable)
let formTitle = ref('Edit Rule')
let formFileName = ref(AppGroupForm)
const searchQuery = ref('');
const showPanel = ref(false)
const fileTypePolicyDetail = ref({})
const formModel = ref({})
const formType = ref('appGroup');
const tableRowData = ref({})
const companyId = ref('')
const fileTypePolicyList = computed(() => store.state.general.fileTypesPolicies);
const statusFilter = ref([]);
const menu = ref()
const isMenuOpen = ref(false)
const items = [
    { label: 'Reset to Defaults', command: () => doAction('reset'), disabled: true },
]
const templatePolicy = ref(false);
const group = ref(null);
const site = ref({});
const template =ref('');
const templateId = ref(0);
const currentRole = ref('');

const saveHandler = async (dataFromForm) => {
    const group = localStorage.getItem("group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
    let body = {
        id: dataFromForm.id ? dataFromForm.id : 0,
        name: dataFromForm.name,
        fileExtensionDaos: dataFromForm.fileExtensionDaos,
        fileExtensionApps: dataFromForm.fileExtensionApps,
        groupId: groupId,
        ruleGuid: fileTypePolicyDetail.value ? fileTypePolicyDetail.value.ruleGuid : null,
        enabled: dataFromForm.enabled,
        expertNotes: dataFromForm.expertNotes,
    }
    if (body.name === undefined || body.fileExtensionDaos === undefined) {
        await Swal.fire({
            title: "Warning",
            html: "Please fill the required fields!",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "OK",
        });
        return;
    }
    if (body.fileExtensionDaos.length === 0) {
        const result = await Swal.fire({
            title: "Error",
            html: "You are about to delete the rule!",
            icon: "error",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
        });
        if (result.isConfirmed) {
            createRule(body);
        }
    } else {
        createRule(body);
    }

}

const createRule = async (body) => {
    try {
        let response =null;
        if(templatePolicy.value){
            body.templateId = templateId.value;
             response = await store.dispatch(
                GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY_TEMPLATE,
                body
            );
        }else{
             response = await store.dispatch(
                GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY,
                body
        );
        }
        loading.value = true;
        if (response.isSuccess) {
            loading.value = false;
        }   
        if(templatePolicy.value){
            getFileTypePolicyListTemplate();
        }else{
            getFileTypePolicyList();
        }
        showPanel.value = false;
    } catch (err) {
        showError(err);
    }
}

const filteredFileExtensionRows = computed(() => {
    const query = searchQuery.value.toLowerCase();
    const rows = fileTypePolicyList.value || [];
    const statusList = statusFilter.value;

    return rows.filter(row => {
        const matchesName = row.fileTypePolicyName?.toLowerCase().includes(query) || false;
        const matchesFileExtension = row.fileExtension?.toLowerCase().includes(query) || false;
        const matchesDriverActionOverride = row.driverActionOverride?.toLowerCase().includes(query) || false;
        const matchesAppList = row.fileExtensionApps?.some(
            file => file?.applicationPath?.toLowerCase().includes(query)
        ) || false;

        const matchesStatus =
            statusList.length === 0 ||
            (statusList.includes("enabled") && row.enabled === true) ||
            (statusList.includes("disabled") && row.enabled === false);

        return (matchesName || matchesFileExtension || matchesDriverActionOverride || matchesAppList) && matchesStatus;
    });
});

const extractErrorMessage = (errors) => {
    if (!errors) return null;
    if (typeof errors === "string") return errors;
    if (Array.isArray(errors)) return errors.flat().join("<br>");
    if (typeof errors === "object") return Object.values(errors).flat().join("<br>");
    return String(errors);
};

function showError(err) {
    const serverData = err?.response?.data ?? err?.data ?? null;
    let msg = "";

    if (serverData?.errors) {
        msg = extractErrorMessage(serverData.errors);
    } else if (serverData?.title) {
        msg = serverData.title;
    } else if (err?.message) {
        msg = err.message;
    } else {
        msg = JSON.stringify(err);
    }

    Swal.fire({
        title: "Error",
        html: msg || "Unexpected error",
        icon: "error"
    });
}


function cancelHandler() {
    console.log('Vazgeçildi')
}
const getFileTypesPolicyDetail = async (type, fileTypesPolicyId) => {
    try {
        const response = templatePolicy.value 
        ? await store.dispatch(GeneralActionTypes.GET_FILE_TYPES_POLICY_DETAIL_TEMPLATE, fileTypesPolicyId) 
        : await store.dispatch(GeneralActionTypes.GET_FILE_TYPES_POLICY_DETAIL, fileTypesPolicyId);
        
        if (response.isSuccess) {
            if (type === 'edit') {
                fileTypePolicyDetail.value = templatePolicy.value ? response.entityData.templatePolicyViewModel.fileExtensions : response.entityData;
                showEdit('Edit Rule', FileTypePolicyForm, 'edit', fileTypePolicyDetail.value)
            } else if (type === 'copy') {
                fileTypePolicyDetail.value = response.entityData;
                showEdit('Add Rule', FileTypePolicyForm, 'copy', fileTypePolicyDetail.value)
            }
        }

    } catch (error) {
        console.error("AppGroup detail fetch error:", error);
    }
};
const getFileTypePolicyList = async () => {
    try {
        await store.dispatch(GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES)
    } finally {
        fileTypePolicyModule.value.component.options.isLoading = false;
    }
}
const getFileTypePolicyListTemplate = async () => {
    try {
        await store.dispatch(GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES_TEMPLATE)
    } finally {
        fileTypePolicyModule.value.component.options.isLoading = false;
    }
}

function updateRowsFromStore() {
    if (fileTypePolicyModule.value?.component?.options) {
        fileTypePolicyModule.value.component.options.rows = fileTypePolicyList.value;
    }
}
watch(fileTypePolicyList, () => {
    updateRowsFromStore()
});

const getPublisherList = async () => {
    const group = JSON.parse(localStorage.getItem("group"))
    const mainId = group ? group.mainid : 0;
    await store.dispatch(GeneralActionTypes.GET_PUBLISHER_LIST, templatePolicy.value ? templateId.value : mainId);
}
const fetchEnumAndStore = async (name) => {
    await store.dispatch(GeneralActionTypes.GET_ENUM_BY_NAME, name);
};

onMounted(() => {
    const company = JSON.parse(localStorage.getItem('company'));
    if (company) {
        companyId.value = company.companyGuid;
    }
    updateRowsFromStore()
    const routeName = useRoute().name;
    if (routeName == 'templateFileTypesPolicy') {
        const templateStr = localStorage.getItem("agms_template");
        const mainId = templateStr ? JSON.parse(templateStr)?.mainid : null;
        templateId.value = mainId;
        currentRole.value = templateStr ? JSON.parse(templateStr)?.template : null;
        templatePolicy.value = true;
        getFileTypePolicyListTemplate();
    } else {
        getFileTypePolicyList();
    }
   

    group.value = JSON.parse(localStorage.getItem("agms_group")) || {};
    site.value = JSON.parse(localStorage.getItem("agms_site")) || {};
});

function showEdit(title, formName, type, data = {}) {
    let formData = {};

    if (type === "add" || type === "edit") {
        formData = { ...data };
    } else if (type === "copy") {
        formData = { ...data };
        delete formData.id;
    }

    formModel.value = formData;
    formTitle.value = title;
    formFileName.value = formName;
    showPanel.value = true;
    formType.value = 'fileTypePolicy';
}
function clearSearch() {
    searchQuery.value = '';
}

const onImport = () => {
    console.log('Import clicked');
};

const doAction = (action) => {
    if (action === 'reset') {
        console.log('Reset clicked');
    }
}
async function editFunction2(rowData) {
    getFileTypesPolicyDetail('edit', templatePolicy.value ? rowData.Id : rowData.id);
}
async function copyFunction(rowData) {
    getFileTypesPolicyDetail('copy', templatePolicy.value ? rowData.Id : rowData.id);
}
async function deleteFileTypePolicy(rowData) {
    const apiMethod = templatePolicy.value ? GeneralActionTypes.DELETE_FILE_TYPES_POLICY_DAO_TEMPLATE : GeneralActionTypes.DELETE_FILE_TYPES_POLICY_DAO;
    const result = await Swal.fire({
        title: "Are You Sure?",
        icon: "warning",
        text: "You are about to delete the selected item!",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
        try {
            let responseApi = null;
            if(templatePolicy.value) {
                rowData.templateId = templateId.value;
                rowData.id = rowData.fileTypesPolicyDaoId;
                responseApi = await store.dispatch(apiMethod, rowData);
            }else {
                responseApi = await store.dispatch(apiMethod, rowData.fileTypesPolicyDaoId);
            }
            if (responseApi.isSuccess) {
                Swal.fire("Deleted!", "File type policy deleted successfully.", "success");
                if(templatePolicy.value){
                    getFileTypePolicyListTemplate();
                }else{
                    getFileTypePolicyList();
                }             
            } else {
                Swal.fire("Error", responseApi.data?.message || "Delete failed.", "error");
            }
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Something went wrong while deleting.", "error");
        }
    }
};

</script>


<style>
.text-muted {
    border-bottom: 1px solid #D2D9E2;
    padding-bottom: 5px;
    padding-left: 0;
    color: #01172F !important;
    font-size: 0.8em;
}

.btn-light {
    background-color: #e1eaf4;
    color: #0b4c8c;
}

.custom-icon-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: transparent;
    border: none;
    box-shadow: none;
    color: #2c5f89;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0;
    font-size: 0.8rem;
}

.div-wrapper #ag-table .ag-icon {
    font-size: 1.1em !important;
}

.custom-icon-button:hover {
    opacity: 0.8;
    cursor: pointer;
}

.icon-circle {
    background-color: #2c5f89;
    color: white;
    border-radius: 50%;
    padding: 8px;
    font-size: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.detail-edit-icon {
    width: 20px;
    height: 20px;
}

.table-border-div {
    border-top: 1px solid #D2D9E2;
    border-left: 1px solid #D2D9E2;
    border-right: 1px solid #D2D9E2;
    padding-top: 30px;
}

.actions-btn {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background-color: #0C4F93;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 8px 12px;
    font-weight: 600;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    min-width: 12.5rem;
}

.actions-btn .label {
    font-size: 0.95rem;
}

.actions-btn .divider {
    width: 1px;
    height: 18px;
    background: rgba(255, 255, 255, 0.6);
    margin-left: auto;
}

.actions-btn .chevron {
    color: #ffffff;
    font-size: 0.9rem;
}

.actions-btn:hover {
    opacity: 0.95;
}

.p-menu {
    border: 1px solid #D2D9E2 !important;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
    border-radius: 10px !important;
    overflow: hidden;
}

.p-menu .p-menuitem-link {
    padding: 0.75rem 1rem !important;
    color: #0B1736 !important;
    font-weight: 600;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
    margin-right: 0.5rem;
}

.p-menu .text-danger {
    color: #C62828 !important;
}

.label-text {
    color: #3C73AA;
}
</style>